var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMemberIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.172,
    height: 28.166,
    viewBox: "0 0 29.172 28.166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_392531_account_friend_human_man_member_icon",
    "data-name": "392531_account_friend_human_man_member_icon",
    transform: "translate(-1.5 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1652",
    "data-name": "Path 1652",
    d: "M22.069,16.414a8.066,8.066,0,1,0-1.725,1.453,12.052,12.052,0,0,1,7.773,10.287H4.055a12.08,12.08,0,0,1,4.1-8.1,1.006,1.006,0,0,0-1.322-1.517A14.087,14.087,0,0,0,2,29.16a1.006,1.006,0,0,0,1.006,1.006h26.16a1,1,0,0,0,1.006-1.006A14.061,14.061,0,0,0,22.069,16.414Zm-12.02-5.365a6.037,6.037,0,1,1,6.037,6.037A6.043,6.043,0,0,1,10.049,11.049Z",
    transform: "translate(0 0)",
    fill: "#616161",
    stroke: "#707070",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberIcon);
export default __webpack_public_path__ + "static/media/member_icon.205724a417fbef670e0d9e5174111cf5.svg";
export { ForwardRef as ReactComponent };